import script from "./OTabelaUsuariosAtivos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaUsuariosAtivos.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaUsuariosAtivos.vue?vue&type=style&index=0&id=d6e4da3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6e4da3c"]])

export default __exports__